<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <QuickTournamentTable/>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import QuickTournamentTable from './QuickTournament/QuickTournamentTable.vue'

  export default {
    name: 'main-tournament-table',
    components: {QuickTournamentTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/tournament/QuickTournament.vue